// extracted by mini-css-extract-plugin
export default {"brand-image":"brands_brand-image__bcaGk","brandProduct":"brands_brandProduct__jPCf8"};